module.exports = __webpack_public_path__ + "img/comma1.376e3d78.svg";